// extracted by mini-css-extract-plugin
module.exports = {"sponsoredTip":"sponsoredTip___1AcgD","image":"image___1BiSa","content":"content___15SIx"};